module.exports = __webpack_public_path__ + "static/var2-cae3de06b8a88ce90dfc421a5bb6c349.jpg";